import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  categoriaSeleccionada: 0,
  categoriasPath: [],
  busca: '',
  ordenamiento: { orden: 'DESC', campo: 'idPublicacion' },
  filtrosCaracteristicas: {},
  filtrosSeleccionados: {},
  caracteristicasActuales: [],
  mapEtiquetaIds: {},
  filtrosLocales: {},
  paginaFiltros: null,
  reiniciaFiltros: false
}

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setCategoria: (state, action) => {
      const { id, label } = action.payload
      state.categoriasPath.push({ id, label })
      state.categoriaSeleccionada = id
    },
    goBackToCategoria: (state, action) => {
      const id = action.payload
      const index = state.categoriasPath.findIndex((c) => c.id === id)
      if (index !== -1) {
        state.categoriasPath = state.categoriasPath.slice(0, index + 1)
        state.categoriaSeleccionada = id
        state.filtrosSeleccionados = {}
        state.busca = ''
      }
    },
    resetCategorias: (state) => {
      state.categoriasPath = []
      state.categoriaSeleccionada = 0
      state.filtrosCaracteristicas = {}
      state.filtrosSeleccionados = {}
      state.busca = ''
    },
    setCategoriaPath: (state, action) => {
      state.categoriasPath = action.payload
      state.categoriaSeleccionada = action.payload[action.payload.length - 1].id
    },

    setOrdenamiento: (state, action) => {
      const { orden, campo } = action.payload || {}
      state.ordenamiento = {
        orden: orden || 'DESC',
        campo: campo || 'idPublicacion'
      }
    },
    setFiltrosCaracteristicas: (state, action) => {
      state.filtrosCaracteristicas = action.payload
    },
    setFiltrosSeleccionados: (state, action) => {
      state.filtrosSeleccionados = action.payload
    },
    setCaracteristicasActuales: (state, action) => {
      state.caracteristicasActuales = action.payload
    },
    setMapEtiquetaIds: (state, action) => {
      state.mapEtiquetaIds = action.payload
    },
    setFiltroLocal: (state, action) => {
      const { key, value } = action.payload
      state.filtrosLocales[key] = value
    },
    resetFiltrosLocales: (state) => {
      state.filtrosLocales = {}
    },
    resetCaracteristicas: (state) => {
      state.caracteristicasActuales = []
      state.mapEtiquetaIds = {}
      state.filtrosCaracteristicas = {}
      state.filtrosSeleccionados = {}
    },
    setBusca: (state, action) => {
      state.busca = action.payload
    },
    setPaginaFiltros: (state, action) => {
      state.paginaFiltros = action.payload
    },
    setReiniciaFiltros: (state, action) => {
      state.reiniciaFiltros = action.payload
    }
  }
})

export const {
  setCategoria,
  goBackToCategoria,
  resetCategorias,
  setCategoriaPath,
  setOrdenamiento,
  setFiltrosCaracteristicas,
  setFiltrosSeleccionados,
  setCaracteristicasActuales,
  setMapEtiquetaIds,
  setFiltroLocal,
  resetFiltrosLocales,
  resetCaracteristicas,
  setBusca,
  setPaginaFiltros,
  setReiniciaFiltros
} = filtersSlice.actions
export default filtersSlice.reducer
